import type { IconDefinition } from '@fortawesome/free-solid-svg-icons';

export type { IconDefinition };

/**
 * A Font Awesome icon as inline SVG (see shared/fa.ts). Decorative by default; give `title`
 * when the icon is the only label of a control.
 */
export function Icon(props: { icon: IconDefinition; title?: string; class?: string; spin?: boolean }) {
  const [w, h, , , path] = props.icon.icon;
  const paths = Array.isArray(path) ? path : [path];
  return (
    <svg
      class={'fa' + (props.spin ? ' fa-spin' : '') + (props.class ? ' ' + props.class : '')}
      viewBox={`0 0 ${w} ${h}`}
      aria-hidden={props.title ? undefined : 'true'}
      role={props.title ? 'img' : undefined}
      focusable="false"
    >
      {props.title && <title>{props.title}</title>}
      {paths.map((d) => <path fill="currentColor" d={d} />)}
    </svg>
  );
}
